import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

export const MenuEmptyStateContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.container, style],
  });

export const MenuEmptyStateTitle = withTypography({
  variant: 'headerOne',
  textAlign: 'center',
});

export const MenuEmptyStateMessage = withTypography({
  variant: 'copyOne',
  textAlign: 'center',
  style: {
    maxWidth: spacing.$64,
    padding: spacing.$2,
  },
});

export const MenuEmptyStateImageWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.imageWrapper, style],
  });

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: spacing.$8,
  },
  imageWrapper: {
    flexDirection: 'row',
    height: spacing.$40,
    marginBottom: spacing.$8,
    marginTop: spacing.$4,
  },
});
